/**
 * ContentCard Component
 * Container for main content areas with consistent styling
 */

import React, { type ReactNode } from 'react';
import { designTokens } from '../../constants/designTokens';

interface ContentCardProps {
  children: ReactNode;
  elevated?: boolean;
  padding?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const ContentCard = React.memo(function ContentCard({
  children,
  elevated = false,
  padding = 'lg',
  className = '',
}: ContentCardProps) {
  const cardClass = `content-card content-card-padding-${padding} ${elevated ? 'content-card-elevated' : ''} ${className}`;

  return (
    <div className={cardClass}>
      {children}

      <style>{`
        .content-card {
          background-color: ${designTokens.components.card.background};
          border: ${designTokens.components.card.border};
          border-radius: ${designTokens.components.card.borderRadius};
          width: 100%;
        }
        
        /* Padding variants */
        .content-card-padding-sm {
          padding: ${designTokens.spacing.md};
        }
        
        .content-card-padding-md {
          padding: ${designTokens.spacing.lg};
        }
        
        .content-card-padding-lg {
          padding: ${designTokens.spacing.xl};
        }
        
        /* Elevated variant - Reduced for flat design */
        .content-card-elevated {
          box-shadow: ${designTokens.shadows.sm};
          border-color: transparent;
          /* Reduce shadow depth to minimize nested appearance */
        }
        
        ${designTokens.media.mobile} {
          .content-card-padding-lg {
            padding: ${designTokens.spacing.lg};
          }
        }
      `}</style>
    </div>
  );
});
